import React from 'react';

import { GRID_DATA as data } from './data';
import { Logo } from './../Logo/Logo';

import { Product } from './../Product/Product';
import { Icon } from './../Icon/Icon';

import './styles.css';

export const ProductsGrid = () => {
    return (
        <div className="products-container" id="productos">
            <div className="yellow-div"> 
                <Logo width="400px" height="60px"/>
                <h1>PRODUCTOS</h1>
            </div>
            <div className="products-grid">
                <div className="products-row">
                    {
                    data.elements.filter((element, i) => { return i <= 4}).map((element, i) => {
                        const { type, id } = element;
                        if (type === 'product'){
                            return <Product key={id} product={element}/>
                        } else {
                            return <Icon key={id} icon={element}/>
                        }
                    })
                }
                </div>
                <div className="products-row">
                    {
                    data.elements.filter((element, i) => { return i > 4}).map((element, i) => {
                        const { type, id } = element;
                        if (type === 'product'){
                            return <Product key={id} product={element}/>
                        } else {
                            return <Icon key={id} icon={element}/>
                        }
                    })
                }
                </div>
                
            </div>
        </div>
    )
};